module.exports = __webpack_public_path__ + "img/list-ordered.d10abd47.svg";